import { space, Icon } from '@primer-io/goat'
import { Link } from '@primer-io/goat-icons'
import Clickable from 'components/Clickable'
import React from 'react'
import styled from 'styled-components'
import fixId from 'utils/fixId'

export const withSideAnchor = Component =>
	function WithSideAnchor({ children, id, ...props }) {
		const newId = fixId(id)

		return (
			<Root as={Component} id={newId} {...props}>
				<StyledClickable to={`#${newId}`}>
					<div>{children}</div>
					{newId && (
						<IconWrapper parent={Component}>
							<Icon as={Link} />
						</IconWrapper>
					)}
				</StyledClickable>
			</Root>
		)
	}

const IconWrapper = styled.div`
	position: relative;
	height: 24px;
`

const Root = styled.div`
	svg {
		color: currentColor;
		opacity: 0;
		transition: opacity 0.1s;
	}

	&:hover,
	&:focus-within {
		svg {
			opacity: 1;
		}
	}
`

const StyledClickable = styled(Clickable)`
	color: initial;
	display: flex;
	place-items: center;
	gap: ${space(2)};

	&:hover {
		text-decoration: none;
	}
`
